import { render, staticRenderFns } from "./facility-space.vue?vue&type=template&id=4f72df5f&"
import script from "./facility-space.vue?vue&type=script&lang=js&"
export * from "./facility-space.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports